import {http, onSuccess, onFail} from "./http";

export const partnerGetList = (eventPassword, blockId) =>
    http.get(`/api/cp/event/${eventPassword}/page/blocks/${blockId}/partners`)
        .then(onSuccess, onFail);

export const partnerCreate = (eventPassword, blockId, payload) =>
    http.post(`/api/cp/event/${eventPassword}/page/blocks/${blockId}/partners`, payload)
        .then(onSuccess, onFail);

export const partnerUpdate = (eventPassword, partnerId, payload) =>
    http.post(`/api/cp/event/${eventPassword}/page/blocks/partners/${partnerId}`, payload)
        .then(onSuccess, onFail);

export const partnersOrderUpdate = (eventPassword, blockId, payload) =>
    http.post(`/api/cp/event/${eventPassword}/page/blocks/${blockId}/partners/sort`, payload)
        .then(onSuccess, onFail);

export const partnerDelete = (eventPassword, partnerId) =>
    http.delete(`/api/cp/event/${eventPassword}/page/blocks/partners/${partnerId}`)
        .then(onSuccess, onFail);
